import React from "react";
import { AlertCircle } from "lucide-react";

const CarrierSelector = ({
  carriers,
  selectedCarrier,
  onChange,
  isDispatcher,
}) => {
  if (!isDispatcher) {
    return null;
  }

  return (
    <div className="bg-tw-neutral-50 border-b border-gray-200 px-6 py-3">
      <div className="flex items-center gap-4">
        <label className="text-sm font-medium text-tw-neutral-700">
          Select Carrier:
        </label>
        <select
          className="flex-1 max-w-md px-3 py-1.5 border border-tw-neutral-300 rounded-lg text-sm bg-white text-tw-neutral-900 focus:outline-none focus:ring-2 focus:ring-tw-info focus:border-tw-info"
          onChange={onChange}
          value={selectedCarrier?.email || ""}
        >
          <option value="">Choose a carrier...</option>
          {carriers.map((carrier) => (
            <option key={carrier.email} value={carrier.email}>
              {carrier.name} {carrier.company_name ? `(${carrier.company_name})` : ""}
            </option>
          ))}
        </select>
        {!selectedCarrier && (
          <div className="flex items-center gap-2 text-tw-warning text-sm">
            <AlertCircle className="h-4 w-4" />
            <span>Please select a carrier to begin</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CarrierSelector;

